module.exports = __webpack_public_path__ + "img/tit1.29b07336.png";